import {RNTagGroupProps} from "shared/controls/RNTags/RNTagGroup";
import {RNTagItemModel} from "shared/controls/RNTags/RNTagItem.Model";

export class RNTagGroupModel{
    Item:RNTagGroupProps;
    Children:RNTagItemModel[];

    constructor(item:RNTagGroupProps) {
        this.Item=item;
        this.Children=[];
    }

    public get Title(){
        return this.Item.Title;
    }


}